import useSWR from 'swr';

import orderBy from 'lodash/orderBy';
import parseISO from 'date-fns/parseISO';

import keycloakService from '../../../../keycloak_service';

import { postToSinatra } from '../../../../utils/api_utils';

export const fetchPipelineVersions = ([pipeline_id, workspace_id]) => {
  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body: JSON.stringify({
      pipeline_id,
      workspace_id
    }),
  };

  return postToSinatra('v1/api/pipelines/list_pipeline_versions', fetchOptions)
}

export const useListPipelineVersions = (pipeline_id, workspace_id) => {
  const {
    data,
    error,
    isLoading,
  } = useSWR([pipeline_id, workspace_id, 'admin-pipeline-versions-list'], fetchPipelineVersions, {
    refreshInterval: 10000,
    loadingTimeout: 1000,
  });

  const sortedVersions = orderBy(data?.pipeline_versions, ({ pipeline_version }) => {
    return pipeline_version?.created_at ? parseISO(pipeline_version?.created_at).getTime() : 0;
  }, 'desc');


  return {
    data: sortedVersions,
    error,
    isLoading,
  }
}

export default useListPipelineVersions;
